import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {
    ButtonModule,
    DirectivesModule, IconModule,
    InputModule, ModalModule,
    SelectModule,
    TitleModule
} from '@sc/portal.fe.lib.ui-core-components';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { SharedComponentsModule } from '../shared/shared-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@sc/pas-common';
import { AutoPlanComponent } from './auto-plan.component';
import { AutoPlanService } from './auto-plan.service';
import { AutoPlanDownloadsService } from './auto-plan-downloads.service';
import { AutoPlanOperationsComponent } from './auto-plan-operations/auto-plan-operations.component';
import { AutoPlanDownloadsComponent } from './downloads/auto-plan-downloads.component';

const components = [
    AutoPlanComponent,
    AutoPlanOperationsComponent,
    AutoPlanDownloadsComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SharedComponentsModule,
        PipesModule,
        CoreModule,
        DirectivesModule,
        ButtonModule,
        InputModule,
        SelectModule,
        TitleModule,
        ModalModule,
        IconModule
    ],
    providers: [
        AutoPlanService,
        AutoPlanDownloadsService
    ],
    declarations: components,
    exports: components,
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AutoPlanModule {
}
